import { FC, useEffect, useRef, useState } from "react";
import styles from "./MapFilter.module.scss";
import { FILTER_ICONS } from "@/lib/ui/icons/map";
import { P2 } from "@/lib/ui/components/Typography";
import { useMapActions } from "@/lib/store/slices/map";
import { useAppSelector } from "@/lib/store/app";
import cl from "classnames";
import { IClassname } from "@/lib/types/classname";
import { useTranslation } from "next-i18next";
import { DownIcon } from "../../../../icons";
import { useObserver } from "../../../../../hooks/useObserver";

const filters = [
  {
    name: "BEACH",
    icon: FILTER_ICONS.FilterBeach,
  },
  {
    name: "SCHOOL",
    icon: FILTER_ICONS.FilterSchool,
  },
  {
    name: "HOSPITAL",
    icon: FILTER_ICONS.FilterHospital,
  },
  {
    name: "MALL",
    icon: FILTER_ICONS.FilterMall,
  },
  {
    name: "RESTAURANT",
    icon: FILTER_ICONS.FilterBar,
  },
  {
    name: "GYM",
    icon: FILTER_ICONS.FilterGym,
  },
  {
    name: "SUPERMARKET",
    icon: FILTER_ICONS.FilterShop,
  },
  {
    name: "ATTRACTION",
    icon: FILTER_ICONS.FilterSS,
  },
  {
    name: "TENNIS",
    icon: FILTER_ICONS.FilterTennis,
  },
  {
    name: "GOLF",
    icon: FILTER_ICONS.FilterGolf,
  },
];

export const MapFilter: FC<IClassname> = ({ className }) => {
  const { toggleFilterQuery } = useMapActions();
  const mapFilter = useAppSelector((state) => state.map.filter);
  const { t } = useTranslation("index");
  const listRef = useRef<HTMLUListElement | null>(null);
  const [shownIcon, setShownIcon] = useState<undefined | 'down' | 'up' | 'none'>('down');

  useEffect(() => {
    if (listRef.current) {
      if (
        listRef.current.scrollHeight - listRef.current.getBoundingClientRect().height <
        20
      ) {
        setShownIcon('none');
      }
    }
  }, []);
  return (
    <div className={cl(styles.filter, className)}>
      <P2 className={styles.filter__title}>{t("placesNearby")}</P2>
      <ul
        className={styles.filter__list}
        ref={listRef}
        onScroll={(e) => {
          const elem = e.currentTarget;
          const height = elem?.getBoundingClientRect()?.height;
          const scrollAmount = elem.scrollTop;
          const scrollHeight = elem.scrollHeight - height;

          if (scrollAmount > +"10" && scrollHeight - scrollAmount > +"10") {
            setShownIcon(undefined)
          } else if (scrollHeight - scrollAmount > +"10") {
            setShownIcon('down')
          } else if (scrollAmount > +"10"){
            setShownIcon('up')
          } else {
            setShownIcon('none')
          }
        }}
      >
        {shownIcon !== 'down' && shownIcon !== 'none' && (
          <li
            className={styles.filter__scrollTop}
            onClick={() => {
              listRef.current?.scrollTo({
                top: 0,
                behavior: "smooth",
              });
            }}
          >
            <DownIcon />
          </li>
        )}
        {filters.map((item, i) => {
          const isActive = mapFilter.includes(item.name) || mapFilter.length === 0;
          return (
            <li
              key={item.name}
              onClick={() => toggleFilterQuery(item.name)}
              className={cl(
                styles.filter__item,
                isActive && styles["filter__item--selected"],
              )}
            >
              {item.icon({})}
              <P2>{t(item.name)}</P2>
            </li>
          );
        })}
        {shownIcon !== 'up' && shownIcon !== 'none'&& (
          <li
            className={styles.filter__scrollBottom}
            onClick={() => {
              listRef.current?.scrollTo({
                top: listRef.current.scrollHeight,
                behavior: "smooth",
              });
            }}
          >
            <DownIcon />
          </li>
        )}
      </ul>
    </div>
  );
};
